import script from "./ViewStatisticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewStatisticsCard.vue?vue&type=script&setup=true&lang=js"

import "./ViewStatisticsCard.vue?vue&type=style&index=0&id=60492df0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60492df0"]])

export default __exports__